import { DndContext } from "@dnd-kit/core";
import styles from "./Main.mobile.module.css";
import { useMainController } from "../Main.controller";
import MenuView from "../../../components/menu/Menu.view";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import CanvasView from "../../../components/canvas/Canvas.view";
import MarketComponentDetailsDialogView from "../../../dialogs/market-component-details-dialog/MarketComponentDetailsDialog.view";
import BackgroundView from "../../../components/background/Background.view.tsx";
import LoaderView from "../../../components/loader/Loader.view.tsx";
import React from "react";
import MenuEnum from "../../../components/menu/Menu.enum.ts";

export default function MainMobileView() {
  const {
    marketComponents,
    isDetailsDialogOpen,
    currentMarketComponent,
    loading,
    handleDragEnd,
    handleDialogOpenDetails,
    handleDialogClose,
  } = useMainController();
  return (
    <div className={styles.main}>
      {isDetailsDialogOpen && (
        <MarketComponentDetailsDialogView
          marketComponent={currentMarketComponent}
          handleDialogCloseClick={handleDialogClose}
        />
      )}

      {loading && <LoaderView />}
      {!loading && (
        <>
          <MenuView menu={MenuEnum.Mobile} />
          <TransformWrapper
            initialScale={0.1}
            minScale={0.1}
            initialPositionX={0}
            initialPositionY={0}
            limitToBounds={false}
          >
            <TransformComponent wrapperClass={styles.zoomContainer}>
              <BackgroundView />
              <DndContext onDragEnd={handleDragEnd}>
                <CanvasView
                  blockX={3}
                  blockY={3}
                  marketComponents={marketComponents}
                  handleDialogOpenDetails={handleDialogOpenDetails}
                />
              </DndContext>
            </TransformComponent>
          </TransformWrapper>
        </>
      )}
    </div>
  );
}
